import styled from "styled-components"

export const Content = styled.div`
 color: var(--green);

 .icon {
  font-size: 1.5rem;
 }
`